import React from 'react';

import * as S from './styles';

const Separator: React.FC = ({ children, ...rest }) => {
  return <S.Wrapper {...rest}>{children}</S.Wrapper>;
};

export default Separator;
